import request from '../util/request';
import SERVER_URL from '../util/seaver';

// 用户登录
function webLogin (reqData) {
  const reqUrl = SERVER_URL + '/user/login';
  return request({
    url: reqUrl,
    method: 'POST',
    data:reqData,
  });
}


export { webLogin };
